import { StateCreator } from "zustand";

import type MapEntityBase from "@/services/map-management/map-entities/map-entity-base";

export interface LegacySlice {
    legacySelected: {
        entity: MapEntityBase | null;
    };
    setLegacySelected: (entity: MapEntityBase | null) => void;
}

/**
 * Legacy slice for compatability with the directly mutated MapEntity classes and zustand's immutability principles
 *
 * Mirrors the selected map entity of the current slice but puts it in a wrapper object to make sure anything
 * we re-create the object each time we set
 *
 * This is only here to support the old classes and should be deleted once we migrate from old classes to regular objects
 *
 */
export const createLegacySlice: StateCreator<LegacySlice, [], [], LegacySlice> = (set) => ({
    legacySelected: {
        entity: null,
    },
    setLegacySelected: (entity: MapEntityBase | null) => set({ legacySelected: { entity } }),
});
